module.exports = __webpack_public_path__ + "img/no_graffics.5e50bd6c.svg";